import React, { useEffect, useState } from "react";
import NavBarTile from "./NavBarTile/NavBarTile";
import "./ProfileNavBar.scss";
// import { useHistory, useLocation } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import GlobalStore from "../../store/globalStore";
import DeviceContext from "../../Services/identifyDevice";
import { compareValues } from "../../utils/sortingUtils";
import {
  authenticateNavBarObj,
  dashboardUrl,
  dematNavBarObj,
  ILeftNavBarArray,
  ipvNavBarObj,
  leftNavBarArray,
} from "../../utils/constants";
import { completeModuleStatus } from "../../Services/globalService";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";
import { AGetStageCompletionStatus } from "../../Services/registration/continueApiService";

export interface ProfileNavBarProps {
  isLoading?: boolean;
  onItemSelect?: () => void;
}

export function checkModuleCompleteness(
  isUploadDocumentsCompleted: boolean,
  dematAccountFound?: any,
  addressAccountFoundLocal?: any
) {
  let userId = 0;
  const tokenObj: string = decryptJwtToken(GlobalStore?.token);
  if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
    let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
    userId = parseInt(tokenMainObj?.UserId?.toString());
  }
  if (
    GlobalStore.stageStatus.isaddressstagecompleted
    //&& (addressAccountFoundLocal == null || addressAccountFoundLocal == undefined)
  ) {
    completeModuleStatus(dashboardUrl.personalIfo);
  }
  // if (
  //   addressAccountFoundLocal !== null &&
  //   addressAccountFoundLocal !== undefined
  // ) {
  //   completeModuleStatus(dashboardUrl.personalIfo);
  // }
  if (
    GlobalStore.stageStatus.isprofiledetailscompleted &&
    GlobalStore.stageStatus.ispersonaldetailscompleted
  )
    completeModuleStatus(dashboardUrl.profile);
  if (isUploadDocumentsCompleted) completeModuleStatus(dashboardUrl.doc);
  if (GlobalStore.stageStatus.isbankdetailscompleted)
    completeModuleStatus(dashboardUrl.bank);
  if (
    GlobalStore.stageStatus.isbrokeragesegmentcompleted &&
    GlobalStore.stageStatus.isbrokerageschemecompleted
  )
    completeModuleStatus(dashboardUrl.plan);
  if (GlobalStore.stageStatus.isipvarificationcompleted) {
    if (GlobalStore.leftNavBarState.length === leftNavBarArray.length) {
      if (!GlobalStore.leftNavBarState?.includes(ipvNavBarObj))
        GlobalStore.setLeftNavBarState((prevState) => [
          ...prevState,
          ipvNavBarObj,
        ]);
    }
    completeModuleStatus(dashboardUrl.ipv);
  }
  if (
    GlobalStore.stageStatus.isdpcompleted !== null &&
    GlobalStore?.stageStatus?.isdpcompleted !== undefined &&
    GlobalStore?.stageStatus?.accountcategory == 2 &&
    GlobalStore?.stageStatus?.isdpcompleted
  ) {
    if (!GlobalStore.leftNavBarState?.includes(dematNavBarObj))
      GlobalStore.setLeftNavBarState((prevState) => [
        ...prevState,
        dematNavBarObj,
      ]);
    if (dematAccountFound !== undefined && dematAccountFound !== null) {
    } else completeModuleStatus(dashboardUrl.demat);
  }
  if (GlobalStore.stageStatus.isesigncompleted)
    completeModuleStatus(dashboardUrl.eSign);
}

const ProfileNavBar: React.FC<ProfileNavBarProps> = (props) => {
  // const history = useHistory();
  const navigate = useNavigate()
  const location = useLocation();
  const [urlPath, setUrlPath] = React.useState<string>();
  const [leftNavBarState, setLeftNavBarState] = React.useState<
    ILeftNavBarArray[]
  >(GlobalStore.leftNavBarState);
  const [topLabel, setTopLabel] = useState("")
  let userId = 0;
  console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
  const tokenObj: string = decryptJwtToken(GlobalStore?.token);
  if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
    let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
    userId = parseInt(tokenMainObj?.UserId?.toString());
  }
  React.useEffect(() => {
    setLeftNavBarState(GlobalStore.leftNavBarState);
    let userId = 0;
    console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
    const tokenObj: string = decryptJwtToken(GlobalStore?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = parseInt(tokenMainObj?.UserId?.toString());
    }
    if (DeviceContext().isDesktop) {
      setUrlPath(location.pathname);
      GlobalStore.dashboardActivetUrl = location.pathname;
    }
    const clientPartialDetails_ao = JSON.parse(
      window.localStorage.getItem("clientPartialDetails_ao") || "{}"
    );
    let filteredLeftNavBar
    if (GlobalStore.applicationID || clientPartialDetails_ao.applicationId) {
      // if (
      //   GlobalStore.isOTCFlow &&
      //   GlobalStore.entityType == "NONINDIVIDUAL"
      // ) {
      //   filteredLeftNavBar = GlobalStore.leftNavBarState.filter(
      //     (item) => item.name !== "Personal Documents"
      //   );
      // }
      if (
        GlobalStore.isKRA ||
        clientPartialDetails_ao.isKRA ||
        GlobalStore.isKYC ||
        clientPartialDetails_ao.isKYC ||
        GlobalStore.isDigiLocker ||
        clientPartialDetails_ao.isDigiLocker
      ) {
        filteredLeftNavBar = GlobalStore.leftNavBarState.filter(
          (item) => item.name !== "Personal Documents"
        );
        if (GlobalStore?.stageStatus?.accountcategory == 2) {
          let filterNavIndexForProfiler = filteredLeftNavBar?.findIndex(
            (filter) => filter?.navUrl == dashboardUrl.profiler
          );
          if (filterNavIndexForProfiler > 0)
            filteredLeftNavBar?.splice(filterNavIndexForProfiler, 1);
          let filterNavIndex = filteredLeftNavBar?.findIndex(
            (filter) => filter?.navUrl == "/plan"
          );
          if (userId !== 0) {
            let filterNavIndex = filteredLeftNavBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.eSign
            );
            if (filterNavIndex > 0)
              filteredLeftNavBar?.splice(filterNavIndex, 1);
            let filterNavIndex2 = filteredLeftNavBar?.findIndex(
              (filter) => filter?.navUrl == dashboardUrl.profiler
            );
            if (filterNavIndex2 > 0)
              filteredLeftNavBar?.splice(filterNavIndex2, 1);
          } else {
            if (
              GlobalStore.isDigiLocker ||
              clientPartialDetails_ao.isDigiLocker
            ) {
            } else {
              let filterNavIndex = filteredLeftNavBar?.findIndex(
                (filter) => filter?.navUrl == dashboardUrl.eSign
              );
              if (filterNavIndex > 0)
                filteredLeftNavBar?.splice(filterNavIndex, 1);
              if (!filteredLeftNavBar?.includes(authenticateNavBarObj))
                filteredLeftNavBar.push(authenticateNavBarObj);
            }
          }

          if (filterNavIndex > 0) filteredLeftNavBar?.splice(filterNavIndex, 1);
          if (!filteredLeftNavBar?.includes(dematNavBarObj))
            filteredLeftNavBar.push(dematNavBarObj);
        }
        if (filteredLeftNavBar && filteredLeftNavBar?.length > 0) {
          setLeftNavBarState(filteredLeftNavBar);
          GlobalStore.setLeftNavBarState(filteredLeftNavBar);
        }
      } else {
        if (GlobalStore?.stageStatus?.accountcategory == 2) {
          let filteredLeftNavBar = [...GlobalStore.leftNavBarState];
          let filterNavIndexForProfiler = filteredLeftNavBar?.findIndex(
            (filter) => filter?.navUrl == dashboardUrl.profiler
          );
          if (filterNavIndexForProfiler > 0)
            filteredLeftNavBar?.splice(filterNavIndexForProfiler, 1);
          let filterNavIndex = filteredLeftNavBar?.findIndex(
            (filter) => filter?.navUrl == "/plan"
          );
          if (filterNavIndex > 0) filteredLeftNavBar?.splice(filterNavIndex, 1);
          if (
            GlobalStore?.isKRA == null ||
            clientPartialDetails_ao.isKRA == null ||
            GlobalStore?.isKRA == undefined ||
            clientPartialDetails_ao.isKRA == undefined ||
            GlobalStore?.isKRA == false ||
            clientPartialDetails_ao.isKRA == false ||
            GlobalStore.isDigiLocker === null ||
            GlobalStore.isDigiLocker == undefined ||
            GlobalStore.isDigiLocker == false ||
            clientPartialDetails_ao.isDigiLocker == null ||
            clientPartialDetails_ao.isDigiLocker == undefined ||
            clientPartialDetails_ao.isDigiLocker == false
          ) {
            if (userId == 0) {
              if (filteredLeftNavBar?.includes(ipvNavBarObj)) {
              } else filteredLeftNavBar?.push(ipvNavBarObj);
              filteredLeftNavBar = filteredLeftNavBar.sort(
                compareValues("priority")
              );
            } else {
              let filterNavIndex = filteredLeftNavBar?.findIndex(
                (filter) => filter?.navUrl == dashboardUrl.eSign
              );
              if (filterNavIndex > 0)
                filteredLeftNavBar?.splice(filterNavIndex, 1);
              let filterNavIndex2 = filteredLeftNavBar?.findIndex(
                (filter) => filter?.navUrl == dashboardUrl.profiler
              );
              if (filterNavIndex2 > 0)
                filteredLeftNavBar?.splice(filterNavIndex2, 1);
            }

            if (!filteredLeftNavBar?.includes(dematNavBarObj))
              filteredLeftNavBar.push(dematNavBarObj);
          }
          if (filteredLeftNavBar && filteredLeftNavBar?.length > 0) {
            setLeftNavBarState(filteredLeftNavBar);
            GlobalStore.setLeftNavBarState(filteredLeftNavBar);
          }
        }
      }
    }
  }, [location.pathname, GlobalStore.isKRA]);

  function onNavTileClick(navUrl: string, index: any) {
    const sidebarOptions = leftNavBarState.sort(compareValues("priority"));
    if (
      index !== 0 && !sidebarOptions[index]['isComplete'] &&
      sidebarOptions[index - 1] &&
      !sidebarOptions[index - 1]["isComplete"]
    ) {
      return false;
    }
    GlobalStore.dashboardActivetUrl = navUrl;
    setUrlPath(navUrl);
    // history.push(navUrl);
    navigate(navUrl)
    props.onItemSelect?.();
  }

  useEffect(() => {
    let filteredLeftNavBar = GlobalStore.leftNavBarState;
    if (
      GlobalStore.isOTCFlow 
      // &&
      // GlobalStore.entityType == "NONINDIVIDUAL"
    ) {
      filteredLeftNavBar = GlobalStore?.leftNavBarState.filter(
        (item) => item?.name !== "Personal Documents"
      );
    }
    setLeftNavBarState(filteredLeftNavBar)
  }, [GlobalStore.leftNavBarState, GlobalStore.isOTCFlow])

  useEffect(() => {
    AGetStageCompletionStatus(
      (res: any) => {
        const responseObj = JSON.parse(res.data);
        setTopLabel(responseObj?.entitytype + " - " + responseObj?.entitysubtype)
      },
      GlobalStore.applicationID
    );
  }, [GlobalStore.applicationID])

  return (
    <div className="prflNavBar">
      <div className="minorLabel">
        {topLabel}
      </div>
      {leftNavBarState.sort(compareValues("priority")).map((tile, index) => (
        <NavBarTile
          key={index}
          isLoading={props.isLoading}
          name={tile.name}
          time={tile.time}
          isActive={
            urlPath === tile.navUrl ||
            GlobalStore.dashboardActivetUrl === tile.navUrl
          }
          isComplete={tile.isComplete}
          navUrl={tile.navUrl}
          logo={tile.logo}
          isClickable={
            index === 0 || tile.isComplete
              ? true
              : leftNavBarState.sort(compareValues("priority"))[index - 1] &&
                leftNavBarState.sort(compareValues("priority"))[index - 1][
                "isComplete"
                ]
                ? true
                : false
          }
          onNavTileClick={() => onNavTileClick(tile.navUrl, index)}
        />
      ))}
    </div>
  );
};

export default ProfileNavBar;
